/*
 * BBC - Rap Map - Logos
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React from 'react';
import LogoBBC1xtra from './assets/logo-bbc-1xtra-2.svg';
import LogoBBCIntroducing from './assets/logo-bbc-introducing-2.svg';
import LogoBBCThree from './assets/logo-bbc-three-2.svg';

const Logos = () => (
    <section className="Logos">
        <h3>Powered By</h3>
        <div className="Logos__Inner">
            <img src={LogoBBC1xtra} alt="BBC 1Xtra" />
            <img src={LogoBBCThree} alt="BBC Three" />
            <img src={LogoBBCIntroducing} alt="BBC Introducing" />
        </div>
    </section>
);

export default Logos;
